/**
 * Format an ISO timestamp as a short relative time string ("Updated <x>").
 * Falls back to a locale date once the gap exceeds a week, so old files don't
 * show an ever-growing "N days ago".
 */
export const relativeTime = (iso: string, now: Date = new Date()): string => {
  const then = new Date(iso);
  const diffMs = now.getTime() - then.getTime();
  const diffSeconds = Math.max(0, Math.round(diffMs / 1000));

  if (diffSeconds < 60) {
    return "just now";
  }

  const diffMinutes = Math.round(diffSeconds / 60);
  if (diffMinutes < 60) {
    return `${diffMinutes} minute${diffMinutes === 1 ? "" : "s"} ago`;
  }

  const diffHours = Math.round(diffMinutes / 60);
  if (diffHours < 24) {
    return `${diffHours} hour${diffHours === 1 ? "" : "s"} ago`;
  }

  const diffDays = Math.round(diffHours / 24);
  if (diffDays < 7) {
    return `${diffDays} day${diffDays === 1 ? "" : "s"} ago`;
  }

  return then.toLocaleDateString();
};
